import { render, staticRenderFns } from "./incubationTest.vue?vue&type=template&id=0481a184&scoped=true&"
import script from "./incubationTest.vue?vue&type=script&lang=js&"
export * from "./incubationTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0481a184",
  null
  
)

export default component.exports